<div class="confirm-container">
  <div class="auth-card">
    <div class="lang-switcher-row">
      <app-language-switcher></app-language-switcher>
    </div>
    <img [src]="brand.logoSrc" class="brand-logo" [alt]="'a11y.logoAlt' | translate" />
    <h2>{{ 'auth.confirmEmail.title' | translate }}</h2>

    @if (state === 'checking') {
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
    } @else if (state === 'signin') {
      <div class="info">{{ 'auth.confirmEmail.confirmedSignIn' | translate }}</div>
      <a class="primary" [routerLink]="loginUrl">{{ 'auth.confirmEmail.goToLogin' | translate }}</a>
    } @else if (state === 'openApp') {
      <div class="info">{{ (confirmedHere ? 'auth.confirmEmail.openAppConfirmed' : 'auth.confirmEmail.openAppInfo') | translate }}</div>
      <a class="primary" [href]="appLink">{{ 'auth.confirmEmail.openApp' | translate }}</a>
    } @else if (state === 'invalid') {
      <div class="error">{{ 'auth.confirmEmail.invalid' | translate }}</div>
      <a class="primary" [routerLink]="loginUrl">{{ 'auth.confirmEmail.goToLogin' | translate }}</a>
    }
  </div>
</div>
